export default __webpack_public_path__ + "static/media/stripe.ec5b45d6.svg";